import { render, staticRenderFns } from "./UsersRol.vue?vue&type=template&id=615110f8"
import script from "./UsersRol.vue?vue&type=script&lang=js"
export * from "./UsersRol.vue?vue&type=script&lang=js"
import style0 from "./UsersRol.vue?vue&type=style&index=0&id=615110f8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports